/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function MailCheckIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="mail-check"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M15.781 17.779L17.501 19.499" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M17.5 19.5A7.961 7.961 0 0 1 21.502 14.698" data-tinysvg-shape="arc" data-tinysvg-arc="25.126 21.787 7.961 7.961 196.694 242.921 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3 8L6.785 10.313C11.479 13.181 12.521 13.181 17.215 10.313L21 8" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14 19.5L4.5 19.5C3.395 19.5 2.5 18.605 2.5 17.5L2.5 6.5C2.5 5.395 3.395 4.5 4.5 4.5L19.5 4.5C20.605 4.5 21.5 5.395 21.5 6.5L21.5 12" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
